module.exports = __webpack_public_path__ + "img/histortReport5.37510149.png";